import React from "react";
import { Box, LinearProgress } from "@mui/material";

export default function Loading() {
  return (
    <Box
      sx={{
        width: "100%",
        height: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        background: "rgba(15, 20, 26, 0.85)",
        backdropFilter: "blur(12px)",
        WebkitBackdropFilter: "blur(12px)",
        gap: 3,
      }}
    >
      {/* Branded logo with pulse animation */}
      <Box
        component="img"
        src="/icon192.png"
        alt="Avro Loading"
        sx={{
          width: 56,
          height: 56,
          borderRadius: 3,
          animation: "avroPulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite",
          "@keyframes avroPulse": {
            "0%, 100%": { opacity: 1, transform: "scale(1)" },
            "50%": { opacity: 0.7, transform: "scale(0.95)" },
          },
        }}
      />

      {/* Progress bar */}
      <Box sx={{ width: 200 }}>
        <LinearProgress
          sx={{
            height: 3,
            borderRadius: 999,
            backgroundColor: "rgba(255,255,255,0.08)",
            "& .MuiLinearProgress-bar": {
              background: "linear-gradient(90deg, #2aa880, #127351)",
              borderRadius: 999,
            },
          }}
        />
      </Box>

      {/* Loading text */}
      <Box
        component="span"
        sx={{
          color: "rgba(255,255,255,0.5)",
          fontSize: 13,
          fontWeight: 500,
          letterSpacing: "0.04em",
          animation: "avroFadeText 2s ease-in-out infinite",
          "@keyframes avroFadeText": {
            "0%, 100%": { opacity: 0.5 },
            "50%": { opacity: 1 },
          },
        }}
      >
        Loading…
      </Box>
    </Box>
  );
}
